export const excludeUndefinedDeep = (obj) => {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        if (value !== undefined) {
            if (value !== null && typeof value === 'object' && !Array.isArray(value)) {
                acc[key] = excludeUndefinedDeep(value);
            }
            else {
                acc[key] = value;
            }
        }
        return acc;
    }, {});
};
//# sourceMappingURL=excludeUndefined.js.map